<template>
  <div class="program-overview">
    <ProgramTile :image="image" :title="title"></ProgramTile>
    <a :href="'/library?sp=' + programId"
    @click="visitProgram"
    @keyup.enter="visitProgram"
    :class="'link-button ' + (inProgram ? 'open' : '')">
      {{buttonText}}
      <RightArrow
      :opacity="1"
      fill="white">
      </RightArrow>
    </a>
    <div class="program-description description" v-html="description"></div>
  </div>
</template>

<style lang="less" scoped>
@import "./shared.less";
.program-overview {
  .link-button {
    display: inline-block;
    color: white;
    background: rgb(0, 127, 255);
    &.open {
      background: rgb(0, 127, 255);
      color: white;
    }
    &:hover{
      background: darken(rgb(0, 127, 255), 10%);
    }
    .right-arrow::v-deep {
      margin-left: 5px;
    }
  }
  p {
    color: white;
    margin-bottom: 10px;
  }
  em {
    font-weight: bold;
  }
  .program-description {
    margin-top: 10px;
  }
}
</style>

<script>
import { mapActions } from "vuex";
import ProgramTile from "@/journeys/ProgramTile";
import RightArrow from "@/common/icons/RightArrow"

export default {
  components: {ProgramTile, RightArrow},
  props: ['title', 'image', 'programId', 'nextStart', 'description', 'started', 'inProgram'],
  data () {
    return {
      
    }
  },
  computed: {
    buttonText() {
      if (this.inProgram) {
        return this.$t('message.open-program');
      }
      else if (this.nextStart <= Date.now()) {
        return this.$t('message.program-details');
      } else {
        return this.$t('message.program-starts-when', [this.$moment(this.nextStart).format("MMMM DD")]);
      }
    }
  },
  methods: {
    close() {
      this.$store.commit("setShowJourney", false);
    },
    visitProgram(event) {
      if (this.started) {
        // since library page is non-vue, just go to href if we're already in the program
        if (this.inProgram) {
          return;
        }
        event.preventDefault()
        this.$router.push({
          name: "program",
          params: {programIdParam: this.programId}
        }, this.close, this.close);
      } else {
        event.preventDefault();
        this.promptStartJourney();
      }
    },
    ...mapActions(["promptStartJourney"])
  }
}
</script>
